import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { RendererOptions } from '@hi-level/2d-renderer';
import { Subscription } from 'rxjs';
import { DrawingSessionService } from '../drawing-session.service';
import { DrawingType } from '../shared-drawing-data';

@Component({
  selector: 'hld-floor-rendering',
  templateUrl: './floor-rendering.component.html',
  styleUrls: ['./floor-rendering.component.scss'],
})
export class FloorRenderingComponent implements OnInit, OnChanges, OnDestroy {
  @Input() options: RendererOptions;
  @Input() drawing: any;
  @Input() floorData: any;
  @Input() drawingType: DrawingType;
  @Output() cutoutDrag = new EventEmitter<any>();
  @ViewChild('renderer', { static: true }) rendererEl: ElementRef;

  zoomLevel = 1;
  maxZoom = 5;
  minZoom = 0.5;
  zoomStep = 0.01;

  private minZoomSub: Subscription;
  private zoomLevelSub: Subscription;
  private onComponentDragSub: Subscription;

  constructor(private drawingSessionService: DrawingSessionService) {}

  ngOnInit(): void {
    this.drawingSessionService.init(
      this.floorData,
      this.drawing,
      this.options,
      this.rendererEl.nativeElement
    );
    this.minZoomSub = this.drawingSessionService.minZoom.subscribe(
      (minZoom) => (this.minZoom = minZoom)
    );
    this.zoomLevelSub = this.drawingSessionService.zoomLevel.subscribe(
      (zoomLevel) => (this.zoomLevel = zoomLevel)
    );
    this.onComponentDragSub =
      this.drawingSessionService.onComponentDrag.subscribe((component) =>
        this.cutoutDrag.emit(component)
      );
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.drawingSessionService.onChanges(changes);
  }

  onZoomChange(newZoomLevel: number): void {
    this.zoomLevel = newZoomLevel;
    this.drawingSessionService.onZoomChange(newZoomLevel);
  }

  ngOnDestroy(): void {
    if (this.minZoomSub) {
      this.minZoomSub.unsubscribe();
    }
    if (this.zoomLevelSub) {
      this.zoomLevelSub.unsubscribe();
    }
    if (this.onComponentDragSub) {
      this.onComponentDragSub.unsubscribe();
    }
  }

  addCutouts(cutouts: any[]): void {
    this.drawingSessionService.addCutouts(cutouts);
  }

  onComponentDragStop(component: any): void {
    this.cutoutDrag.emit(
      this.drawingSessionService.onComponentDragStop(component)
    );
  }

  getImageUrl(): string {
    return this.drawingSessionService.getImageUrl();
  }

  setViewStyle(newStyle: string): void {
    this.drawingSessionService.setViewStyle(newStyle);
  }
}
